import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'workItemLink' })
export class WorkItemLinkPipe implements PipeTransform {

  private readonly URLS: Record<string, string> = {
    external: 'https://dev.azure.com/BNH365/AutofacetsBNH/_workitems/edit/',
    internal: 'http://10.0.0.144/GTLProjects/4491_Customer_Online_Widget/_workitems/edit/',
  };

  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(html: string, type: 'external' | 'internal' = 'external'): SafeHtml {
    if (!html) { return ''; }
    const url = this.URLS[type];
    const normalized = html.split('&nbsp;').join(' ');
    const linked = normalized.replace(
      /(User Story|Task|Bug)\s+(\d+):/g,
      `<a href="${url}$2" target="_blank" rel="noopener noreferrer" class="wi-link">$1 $2:</a>`
    );
    return this.sanitizer.bypassSecurityTrustHtml(linked);
  }
}
